<ng-container *transloco="let t">
  <div
    class="no-results"
    [class.small]="size === 'small'"
    [class.normal]="size === 'normal'"
    [class.large]="size === 'large'"
    [style.width]="width$ | async"
  >
    <div class="{{ type }}-icon">
      <span class="fa-stack" [class.fa-3x]="size === 'small'" [class.fa-6x]="size === 'normal'">
        <ng-container *ngIf="type === 'no-results'">
          <i *ngIf="showIconLayer1" class="fa-thin fa-magnifying-glass fa-stack-1x"></i>
          <i *ngIf="showIconLayer2" class="fa fa-exclamation fa-stack-2x" [class.fa-fade]="animate"></i>
        </ng-container>

        <ng-container *ngIf="type === 'no-records'">
          <i *ngIf="showIconLayer1" class="fa-thin fa-folder-blank fa-stack-1x"></i>
          <i *ngIf="showIconLayer2" class="fa fa-exclamation fa-stack-2x" [class.fa-fade]="animate"></i>
        </ng-container>

        <ng-container *ngIf="type !== 'no-results' && type !== 'no-records'">
          <i *ngIf="showIconLayer1" [ngClass]="iconLayer1"></i>
          <i *ngIf="showIconLayer2" [ngClass]="iconLayer2" [class.fa-fade]="animate"></i>
        </ng-container>
      </span>
    </div>

    <div class="title">
      <h2 *ngIf="type === 'no-results'">{{ t('core.components.grid.no_results.no_results_found') }}</h2>
      <h2 *ngIf="type === 'no-records'">{{ t('core.components.grid.no_results.no_records_found') }}</h2>
      <h2 *ngIf="type !== 'no-results' && type !== 'no-records'">{{ title }}</h2>
    </div>

    <div class="description" *ngIf="showDescription">
      <ng-container *ngIf="type === 'no-results'">
        {{ t('core.components.grid.no_results.adjust_search_params') }}
      </ng-container>
      <ng-container *ngIf="type === 'no-records'">
        {{ t('core.components.grid.no_results.adjust_search_params') }}
      </ng-container>
      <ng-container *ngIf="type !== 'no-results' && type !== 'no-records'">
        {{ description }}
      </ng-container>
    </div>
  </div>
</ng-container>
